import ParkPassAPI from "../parkpassAxiosConfig";

export const getNotifiedInfractions = async (params = {}) => {
  try {
    const {
      page = 1,
      pageSize = 25,
      userNotified,
      notifiedFrom,
      notifiedTo,
      matricule,
      status,
    } = params;

    const queryParams = {
      page,
      page_size: pageSize,
    };

    if (userNotified !== undefined && userNotified !== null) {
      queryParams.user_notified = userNotified;
    }
    if (notifiedFrom) queryParams.notified_from = notifiedFrom;
    if (notifiedTo) queryParams.notified_to = notifiedTo;
    if (matricule) queryParams.matricule = matricule;
    if (status) queryParams.status = status;

    const response = await ParkPassAPI.get("/v1/infractions/notified", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
